import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=6a20cd30&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=6a20cd30&prod&lang=scss&scoped=true"
import style1 from "./preview.vue?vue&type=style&index=1&id=6a20cd30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20cd30",
  null
  
)

export default component.exports